<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="row"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
      >
        <div class="kaoji-title">{{ row.danwei }}{{ row.clubleixing }}</div>
        <div class="kaoji-mine">我的身份：{{ row.clubleixing }}{{ row.user_type }}</div>

<!--        <el-row :gutter="20">-->
<!--          <el-col :span="12">-->
<!--            <el-form-item>-->
<!--              <el-link>基本资料</el-link>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <van-cell-group>
          <van-cell title="基本资料" is-link @click="toNext('ClubDetailBase')"></van-cell>
          <van-cell title="成员信息" is-link @click="toNext('ClubDetailCommunity')"></van-cell>
          <van-cell title="先进申报" is-link @click="toNext('ClubDetailShenbao')"></van-cell>
          <van-cell title="考级" is-link @click="toNext('ClubDetailKaoji')"></van-cell>
          <van-cell title="积分情况" is-link @click="toNext('ClubDetailScore')"></van-cell>
          <van-cell title="星级俱乐部升级" is-link @click="toNext('ClubDetailDanwei')"></van-cell>
          <van-cell title="风采展示" is-link @click="toNext('ClubDetailFengcai')"></van-cell>
          <!--      <van-cell title="新闻广告" is-link ></van-cell>-->
          <van-cell title="数据导出" is-link></van-cell>

          <!--      <van-cell title="申请授牌" is-link ></van-cell>-->
          <div style="height: 10px"></div>
        </van-cell-group>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
      </el-form>
    </div>
  </div>
</template>
<style scoped>
.kaoji-title {
  padding: 15px;
  font-size: 24px;
  text-align: center;
}

.kaoji-mine {
  padding: 0 15px 20px;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubDetail',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      id: 0,
      row: {}
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.id = this.$route.query.id;
    document.title = "俱乐部详情"
    that.fetch();

  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/club/clubDetail', {
        id: that.id,
      }, (res) => {
        that.row = res.data;
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    },
    unbind() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除单位认证吗?'
      }).then(() => {

        that.$api.post('/api/danwei/unbind', {}, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },

    toNext(name) {
      rbLink({name: name, query: {id: this.row.id}})
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// ClubDetail.vue?0a17cbf6